import { Catalog, setupI18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { useAsyncEffect, useToggleState } from '@speedlo/hooks'
import React from 'react'

import { LoaderSpinner } from './atoms/LoaderSpinner'
import { appConfig } from './config'
import { logLang } from './helpers/logger'

export const i18n = setupI18n()

export const I18nManager: React.SFC = ({ children }) => {
  const [isReady, setReady] = useToggleState()
  const language = detectLanguage()

  useAsyncEffect(async () => {
    await changeLanguage(language)
    setReady()
  })

  if (isReady === false) {
    return <LoaderSpinner />
  }

  return isReady ? (
    <I18nProvider language={language} i18n={i18n}>
      {children}
    </I18nProvider>
  ) : (
    <LoaderSpinner />
  )
}

export async function changeLanguage(lang: string) {
  if (!appConfig.supportedLanguages.includes(lang)) {
    logLang('language %s is not supported')
    return false
  }
  await loadCatalog(lang)
  i18n.activate(lang)
  logLang('changed to %s', lang)
  return true
}

export function detectLanguage() {
  return appConfig.fallbackLanguage
}

async function loadCatalog(lang: string) {
  let catalog: Catalog
  if (process.env.NODE_ENV !== 'production') {
    // prettier-ignore
    catalog = await import(
      /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
      `@lingui/loader!./locale/${lang}/messages.po`
    )
  } else {
    // prettier-ignore
    catalog = await import(
      /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
      `./locale/${lang}/messages.js`
    )
  }
  i18n.load({ [lang]: catalog })
  logLang('loaded catalog %s', lang)
}
